import clsx from 'clsx';
import React from 'react';

import { Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import { IValidationResult } from '../../../../services/ContentValidator/interfaces/validation.interface';
import { IErrorDetailsData } from '../../interfaces/detailsData.interface';
import AnalysisRow from '../AnalysisRow/AnalysisRow';
import useStyles from './styles';

interface IErrorListProps {
  analysis: IValidationResult
  onOpenDetails: (details: IErrorDetailsData) => void;
}

const ErrorList: React.FC<IErrorListProps> = ({
  analysis,
  onOpenDetails,
}) => {
  const theme: any = useTheme();
  const classes = useStyles();

  return (
    <>
      {
        analysis.errors.length || analysis.warnings.length
          ? <Typography className={classes.description}>You must fix these problems before publish or send to revision:</Typography>
          : <Typography className={clsx(classes.description, classes.allDoneText)}>All fine! Good work :)</Typography>
      }

      {
        analysis.errors.length > 0 && (
          <>
            <Typography variant="h5" className={classes.analysisTitle}>Problems:</Typography>
            {analysis.errors.map(error => (
              <AnalysisRow
                key={error.message}
                error={error}
                iconColor={theme.new.pallette.red.primary}
                extraClassNames={[classes.errorIcon]}
                icon={['far', 'times-circle']}
                onOpenDetails={onOpenDetails}
              />
            ))}
          </>
        )
      }
      {
        analysis.warnings.length > 0 && (
          <>
            <Typography variant="h5" className={clsx(classes.analysisTitle, classes.recommendedAnalysisTitle)}>Recommended:</Typography>
            {analysis.warnings.map(warning => (
              <AnalysisRow
                key={warning.message}
                error={warning}
                iconColor={theme.new.pallette.orange.primary}
                extraClassNames={[classes.warnIcon]}
                icon={['fas', 'exclamation-triangle']}
                onOpenDetails={onOpenDetails}
              />
            ))}
          </>
        )
      }
    </>
  );
};

export default ErrorList;
